// extracted by mini-css-extract-plugin
module.exports = {"root":"FootnoteFooter_root__3fnNu","body":"FootnoteFooter_body__Ilqc9","treatment":"FootnoteFooter_treatment__gGxZc"};